import { useState } from "react";
import dropdownArrow from '../../assets/images/icon-dropdown-arrow.svg';

export interface ISelectOption {
    id: string | number;
    name: string;
}

export interface ISelectProps {
    optionList: Array<ISelectOption>;
    selectedId: string | number;
    onSelectedChanged: (item: ISelectOption) => void;
    props: any;
}

export default function Select(props: ISelectProps) {
    const [selectedId, setSelectedId] = useState<string | number>(props.selectedId);
    const [isOpened, setIsOpened] = useState<boolean>(false);

    return (<>
        <input {...props.props} type="hidden" value={selectedId} />

        <div className={`innsworth-select ${isOpened ? 'opened' : ''}`}>
            <div className="inner-container">

                <div onClick={() => { setIsOpened(!isOpened) }} className="options-header">
                    <p >{props.optionList?.find((x: any) => x.id === selectedId)?.name}</p>
                    <img src={dropdownArrow} alt="arrow" />
                </div>

                <div className="options-container">
                    <div className="select-options">
                        {
                            props.optionList?.map((x: ISelectOption) => <a onClick={() => {
                                props.onSelectedChanged(x);
                                setSelectedId(x.id);
                                setIsOpened(false);
                            }} key={x.id} className={x.id === selectedId ? 'selected' : ''}> {x.name} </a>)
                        }
                    </div>
                </div>
            </div>
        </div >
    </>);
}